(() => {
  const labels = window.feohwynnSliderLabels;
  if (!labels || typeof window.Swiper?.extendDefaults !== 'function') return;
  const messages = Object.fromEntries(Object.entries(labels).map(([key, value]) => [
    key, value.replaceAll('[index]', '{{index}}').replaceAll('[total]', '{{slidesLength}}')
  ]));
  window.Swiper.extendDefaults({ a11y: messages });
})();

(() => {
  const labelMerchantWidget = () => {
    const frame = document.getElementById('merchantwidgetiframe');
    if (!frame) return false;
    if (!frame.getAttribute('title')?.trim()) {
      frame.setAttribute('title', 'Google-Händlerbewertungen');
    }
    return true;
  };
  labelMerchantWidget();
  const observer = new MutationObserver(labelMerchantWidget);
  observer.observe(document.body, { childList: true, subtree: true });
})();
